import { render, staticRenderFns } from "./headCont.vue?vue&type=template&id=a7644e70&scoped=true&"
import script from "./headCont.vue?vue&type=script&lang=js&"
export * from "./headCont.vue?vue&type=script&lang=js&"
import style0 from "./headCont.vue?vue&type=style&index=0&id=a7644e70&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a7644e70",
  null
  
)

export default component.exports